import React, { useEffect, useState } from 'react'
import "./ManageEvents.css";
import SingleEvent from '../../components/manageEvents/SingleEvent';
import { Button, CircularProgress, Container } from '@mui/material';
import DefaultHeading from '../../components/heading/DefaultHeading';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import { dataTobeSavedType, eventsType, singleEventType, singleEventofDatabaseType } from './ManageEventsType';
import { eventList } from './ManageEventConfig';
import EventsAdder from '../../components/manageEvents/EventsAdder';
import { getMetaData, postConfiguration, updateConfiguration } from '../../services/uiConfigService';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { configurationAttributeType } from '../../types';
import { InfoOutlined } from '@material-ui/icons';
import NoDataMessage from '../../components/manageEvents/NoEventsMessage';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';



function ManageEvents(): JSX.Element {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "Manage Events"
    const CUR_COMPONENT_COMMON="commonPortal";
    const [events, setEvents] = useState<eventsType>([]);
    const [options, setOptions] = useState<Array<string>>([]);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [initalLoading, setInitialLoading] = useState<boolean>(false);
    const handleAddTypeClick = (selectedEventsIds: Array<string>): void => {
        const newSelectedEvents = selectedEventsIds.map((option: string) => {
            return {
                status: "disabled",
                id: option,
                mappings: {
                    database: { name: option, params: [] },
                    firebase: { name: option, params: [] },
                    moengage: { name: option, params: [] }
                }
            }
        })
        setEvents((pre: any) => ([...pre, ...newSelectedEvents]));
    }

    const handleDeleteEvent = (eventId: string): void => {
        setEvents((pre) => (pre?.filter((event) => event.id !== eventId)));
    }

    async function getEventsData(): Promise<void> {
        setInitialLoading(true);
        try {
            const response = await getMetaData("clientconfig", "analytics_config");
            let data = {};
            if (response) {
                const eventsData = response.find((item: any) => item.name === "events");
                if (!eventsData) data = {};
                else {
                    data = deepClone(eventsData.value[0]);
                }
            }
            setEvents(convertObjectToArray(data).map((event) => {
                //convert the data coming from backend to array of objects
                const tempEvent = { ...event };
                for (let type in tempEvent.mappings) {
                    tempEvent.mappings[type].params = convertObjectToArray(tempEvent.mappings[type].params).map((item) => item.key);
                }
                return tempEvent;
            }));

        } catch (error) {
            console.error(error)
        } finally {
            setInitialLoading(false);
        }

    }

    function filterOptions() {
        const listOfEvents = [...eventList];

        let eventSet = new Set(listOfEvents);
        events?.map((event) => {
            eventSet.delete(event.id)
        })

        setOptions(() => [...Array.from(eventSet)])
    }

    const updateMappingStateInsideEvents = (eventId: string, updatedMapping: any): void => {
        setEvents((pre: any) => {
            const newEvents = pre.map((event: singleEventType) => {
                if (event.id === eventId) {
                    return {
                        ...event,
                        mappings: { ...updatedMapping }
                    }
                }
                else return event;
            })

            return newEvents;
        })
    }

    function convertObjectToArray(obj: any): Array<any> {
        return obj ? Object.keys(obj).map((item) => {
            if (typeof obj[item] === "string") return { value: obj[item], key: item };
            else return { ...obj[item], key: item }
        }) : [];
    }

    const convertArrayOfObjectToObject = (arrayOfObjects: Array<Record<string, string>>): Record<string, string> => {
        if (!arrayOfObjects || !Array.isArray(arrayOfObjects)) throw Error("data is not an array");
        return arrayOfObjects.reduce((result, obj) => {
            result[obj.key] = obj.value;
            return result
        }, {});
    };

    const isParamKeyPresentInConfig = (params: Record<string, string>, key: string) => {
        return params && params.hasOwnProperty(key);
    }

    const validateAllData = (data: any): string | null => {
        if (!data || Object.keys(data).length === 0) return "Empty Data cannot be saved";

        let message = ''
        Object.keys(data).forEach((key) => {
            if (Object.keys(data[key].mappings).length === 0 && message.trim() === '') {
                message += `Select atleast a single param from the empty event(s).`;
            }
        })
        return message;
    }

    const saveConfiguration = async (): Promise<void> => {
        setIsSaving(true)
        const configName = "analytics_config"
        let response = await getMetaData("clientconfig", configName);
        let config_data: any = {};

        if (response) {
            const eventConfig = response.find((item: any) => item.name === "events");
            if (eventConfig) {
                config_data = deepClone({ ...eventConfig.value[0] });
            }
        }
        const dataToBeSaved: dataTobeSavedType = {};
        events?.forEach((event) => {
            const isIdPresentInConfig = config_data.hasOwnProperty(event.id);
            const singleEvent: singleEventofDatabaseType = {
                status: isIdPresentInConfig ? config_data[event.id].status : event.status,
                mappings: {
                    firebase: {
                        name: isIdPresentInConfig ? config_data[event.id].mappings?.firebase?.name ? config_data[event.id].mappings.firebase.name : event.id : event.id,
                        params: event.mappings?.firebase?.params ? convertArrayOfObjectToObject(event.mappings.firebase.params?.map((key: string) => ({ key, value: isParamKeyPresentInConfig(config_data[event.id]?.mappings?.firebase?.params, key) ? config_data[event.id]?.mappings?.firebase?.params[key] : key }))) : {}
                    },
                    moengage: {
                        name: isIdPresentInConfig ? config_data[event.id].mappings?.moengage?.name ? config_data[event.id].mappings.moengage.name : event.id : event.id,
                        params: event.mappings?.moengage?.params ? convertArrayOfObjectToObject(event.mappings.moengage.params?.map((key: string) => ({ key, value: isParamKeyPresentInConfig(config_data[event.id]?.mappings?.moengage?.params, key) ? config_data[event.id]?.mappings?.moengage?.params[key] : key }))) : {}
                    },
                    database: {
                        name: isIdPresentInConfig ? config_data[event.id].mappings?.database?.name ? config_data[event.id].mappings.database.name : event.id : event.id,
                        params: event.mappings?.database?.params ? convertArrayOfObjectToObject(event.mappings.database.params?.map((key: string) => ({ key, value: isParamKeyPresentInConfig(config_data[event.id]?.mappings?.database?.params, key) ? config_data[event.id]?.mappings?.database?.params[key] : key }))) : {}
                    }
                },
                id: isIdPresentInConfig ? config_data[event.id].id : event.id
            }

            // delete mappings if params are empty
            if (singleEvent.mappings.firebase && Object.keys(singleEvent.mappings.firebase.params).length === 0) {
                delete singleEvent['mappings']['firebase']
            }

            if (singleEvent.mappings.database && Object.keys(singleEvent?.mappings?.database.params)?.length === 0) {
                delete singleEvent['mappings']['database']
            }

            if (singleEvent.mappings.moengage && Object.keys(singleEvent?.mappings?.moengage.params)?.length === 0) {
                delete singleEvent['mappings']['moengage']
            }

            dataToBeSaved[event.id] = singleEvent

        })

        try {
            const validationResults = validateAllData(dataToBeSaved);

            if (!validationResults || validationResults === "") {
                let configData = [{
                    name: "events",
                    type: "list",
                    value: [dataToBeSaved],
                    description: "list of events",
                    possibleVals: [],
                    docUrl: "",
                }]
                let result = null
                if (!response) {
                    result = await postConfiguration(configName, configData as configurationAttributeType<any>[])
                } else {
                    const indexOfEventInConfig = response.findIndex((item: { name: string }) => item.name === "events");
                    if (indexOfEventInConfig === -1) {
                        configData = [...configData, ...response]
                    } else {
                        response[indexOfEventInConfig] = configData[0];
                        configData = [...response];
                    }
                    result = await updateConfiguration(configName, configData as configurationAttributeType<any>[])
                }

                if (result.data?.status === "Failure") {
                    throw new Error("")
                } else {
                    openPopup('Success', `Event${events && events?.length > 1 ? 's' : ''} saved`)
                }
            } else {
                openPopup("Error", validationResults)
            }
        } catch (error) {
            console.error(error);
            openPopup('Error', "An error occurred while saving data.")
        } finally {
            setIsSaving(false);
        }
    }

    useEffect(() => {
        getEventsData();
    }, [])

    useEffect(() => {
        filterOptions()
    }, [events])

    return (
        <div className='manage-events-wrapper'>
            <div className="manage-events-header">
                <DefaultHeading heading={translate(TranslationEnum.manage_events,"Manage Events")} showDefaultBackButton />
                <EventsAdder options={options} handleAddClick={handleAddTypeClick} saveConfiguration={saveConfiguration} />
            </div>
            <div className="manage-events-main-content">
                {
                    initalLoading ? <Container className='manage-event-loading-wrapper'>
                        <CircularProgress size={70} />
                    </Container> : events.length === 0 ? <NoDataMessage message={translate(TranslationEnum.manage_events,"Add Events from the dropdown")} icon={<InfoOutlined />} /> :
                        <div className="events-list">
                            {
                                events?.map((event) => {
                                    return <SingleEvent key={event.id} event={event} updateMappingStateInsideEvents={updateMappingStateInsideEvents} handleDeleteEvent={handleDeleteEvent} />
                                })
                            }
                        </div>
                }
            </div>
            <div className="manage-events-footer">
                <Button className='manage-event-save-button' variant="contained" sx={{ backgroundColor: "#23c6b0" }} onClick={saveConfiguration} disabled={isSaving}>
                    {
                        isSaving ? <>{translate(TranslationEnum.common_portal,"Saving..")}</> : <>{translate(TranslationEnum.common_portal,"SAVE")}</>
                    }
                </Button>
            </div>

        </div>
    )
}

export default ManageEvents